import SurveySection from './SurveySection';

export default SurveySection;
